import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';

export class StatusUpdateBus extends BaseBus
{
  CID(): any {
      return this.id;
    }

    id: any;
    statusId: any;
}
